import React from "react";
import displayConditions from "../../utils";
import useForm from "../context/useForm";
import Element from "../Element";
import qualifySectionElements from "./elements";
import styles from "./styles.module.scss";

const QualifyingSection = () => {
  const { state: responses, handleChange } = useForm();
  const shouldDisplay = displayConditions(responses);
  return (
    <section className={styles.sectionContainer}>
      <h2 data-step-title={qualifySectionElements.title}>{qualifySectionElements.title}</h2>
      <div className={styles.elementContainer}>
        {qualifySectionElements.elements.map(element => {
          if (shouldDisplay(element.id)) {
            return <Element key={element.id} element={element} responses={responses} handleChange={handleChange} />;
          }
          return null;
        })}
      </div>
    </section>
  );
};

export default QualifyingSection;
